import React from "react";
import { GsdReadableBlock } from "./GsdReadableBlock.jsx";

/**
 * Enveloppe auth premium — extrait PokerPUR AuthShell / auth-shell.css.
 */
export function GsdAuthShell({
  title,
  subtitle,
  demoNotice,
  children,
  wide = false,
  testId = "gsd-auth-shell",
}) {
  return (
    <div className="gsd-auth-shell" data-testid={testId}>
      <div className={`gsd-auth-shell__card${wide ? " gsd-auth-shell__card--wide" : ""}`}>
        {(title || subtitle) && (
          <header className="gsd-auth-shell__head">
            {title ? <h1 className="gsd-auth-shell__title">{title}</h1> : null}
            {subtitle ? <p className="gsd-auth-shell__subtitle">{subtitle}</p> : null}
            {demoNotice ? <p className="gsd-auth-shell__demo" data-testid="gsd-auth-demo-notice">{demoNotice}</p> : null}
          </header>
        )}
        {children}
      </div>
    </div>
  );
}

export function GsdAuthLayout({ children, testId = "gsd-auth-layout" }) {
  return (
    <div className="gsd-auth-layout" data-testid={testId}>
      <div className="gsd-auth-layout__inner">{children}</div>
    </div>
  );
}

export function GsdLoginPage({
  title,
  subtitle,
  demoNotice,
  loginCard,
  testId = "gsd-login-page",
}) {
  return (
    <GsdAuthLayout testId={testId}>
      <GsdAuthShell title={title} subtitle={subtitle} demoNotice={demoNotice} testId="gsd-login-auth-shell">
        {loginCard}
      </GsdAuthShell>
    </GsdAuthLayout>
  );
}

export function GsdAccountRequestForm({
  locale = "fr",
  roleOptions = [],
  onSubmit,
  testId = "gsd-account-request-form",
}) {
  const labels =
    locale === "en"
      ? {
          name: "Full name",
          email: "Email",
          role: "Requested role",
          org: "Organization / Dojo",
          message: "Message",
          submit: "Submit request",
        }
      : {
          name: "Nom complet",
          email: "Courriel",
          role: "Rôle demandé",
          org: "Organisation / Dojo",
          message: "Message",
          submit: "Envoyer la demande",
        };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    onSubmit?.({
      name: fd.get("name"),
      email: fd.get("email"),
      role: fd.get("role"),
      organization: fd.get("organization"),
      message: fd.get("message"),
    });
  };

  return (
    <form className="gsd-account-request-form" onSubmit={handleSubmit} data-testid={testId}>
      <label>
        {labels.name}
        <input name="name" required data-testid="gsd-account-request-name" />
      </label>
      <label>
        {labels.email}
        <input name="email" type="email" required data-testid="gsd-account-request-email" />
      </label>
      <label>
        {labels.role}
        <select name="role" required data-testid="gsd-account-request-role">
          {roleOptions.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        {labels.org}
        <input name="organization" data-testid="gsd-account-request-org" />
      </label>
      <label>
        {labels.message}
        <textarea name="message" rows={4} data-testid="gsd-account-request-message" />
      </label>
      <button type="submit" className="gsd-account-request-form__submit" data-testid="gsd-account-request-submit">
        {labels.submit}
      </button>
    </form>
  );
}

export function GsdAccountRequestPage({ title, subtitle, children, testId = "gsd-account-request-page" }) {
  return (
    <GsdAuthLayout testId={testId}>
      <GsdAuthShell title={title} subtitle={subtitle} wide testId="gsd-account-request-auth-shell">
        {children}
      </GsdAuthShell>
    </GsdAuthLayout>
  );
}

export function GsdLoginCard(props) {
  return props.component ? <props.component {...props} /> : null;
}
